import { autoinject, observable, bindable } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { ProductType } from '_models/dtos';
import { SessionData } from '_models/session-data';
import { UrlService } from '_services/url-service';
import * as Dto from '_models/dtos';

@autoinject
export class ProgressWizard {

    private _url: UrlService;

    constructor(
        public router: Router,
        public sd: SessionData
    ) {
        this._url = new UrlService();
    }
    
    @bindable step = '1';

    step1Class = 'active';
    step2Class = '';
    step3Class = '';

    attached() {
        this.updateWizardProgress();
    }

    getCanCutImagePath(product: Dto.ProductType) {
        var relativeUrl = `~/images/CanCuts/${product.canCutImage}`;
        var url = this._url.build(relativeUrl);
        return url;
    }

    updateWizardProgress() {
        // Set CSS classes
        switch (this.step) {
            case '2':
                this.step1Class = 'completed';
                this.step2Class = 'current';
                this.step3Class = '';
                break;
            case '3':
                this.step1Class = 'completed';
                this.step2Class = 'completed';
                this.step3Class = 'current';
                break;
            case '1':
            default:
                this.step1Class = 'current';
                this.step2Class = '';
                this.step3Class = '';
        }
    }

    editProductType() {
        this.sd.wizard.index = 0;
        this.sd.save();
    }
}